import React, { useEffect, useState } from 'react';

import { useSnackbar } from 'notistack';
import { useParams } from 'react-router';
import { useHistory } from 'react-router-dom';

import { Box, CircularProgress, Typography } from '@mui/material';

import { getBedbankOrderByBookingNumber } from '~/services/OrdersService';

export default function PurchasesPageBookingNumberContainer() {
  const { bookingNumber } = useParams<{ bookingNumber?: string }>();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrderAndRedirect = async () => {
      if (!bookingNumber) {
        enqueueSnackbar('Booking number is required', { variant: 'error' });
        history.push('/purchases');
        return;
      }

      try {
        setLoading(true);
        const orders = await getBedbankOrderByBookingNumber(bookingNumber);
        if (orders.length === 0) {
          enqueueSnackbar(`No order found for booking number: ${bookingNumber}`, { variant: 'error' });
          history.push('/purchases');
          return;
        }
        const order = orders[0];
        history.push(`/purchases/${order.id}`);
      } catch (error) {
        console.error('Error fetching order by booking number:', error);
        enqueueSnackbar(`Failed to find order for booking number: ${bookingNumber}`, { variant: 'error' });
        history.push('/purchases');
      } finally {
        setLoading(false);
      }
    };

    fetchOrderAndRedirect();
  }, [bookingNumber, history, enqueueSnackbar]);

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '50vh',
          gap: 2,
        }}
      >
        <CircularProgress />
        <Typography variant="body1">Looking up order for booking number: {bookingNumber}</Typography>
      </Box>
    );
  }

  return null;
}
